import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  icon: {
    position: 'absolute',
    left: 11,
    top: 18,
    bottom: 6,
    zIndex: 1,
    width: 22,
    fill: palette.primary.main,
  },
  activeIcon: {
    color: palette.primary.main,
  },
  label: { marginBottom: -7 },
  textField: {
    paddingLeft: 40,
  },
  iconButton: {
    color: custom.grey[10],
  },
}));
